import type { CctpSdkContext } from '@/types/sdk/experimental/cctp/cctpTypes'
import type { CctpMoneyInTransitResponse } from '@vaultsfyi/common/schemas'
import type { Address } from 'viem'
import { parseCctpError } from './parseCctpError'

export const getCctpMoneyInTransit = async (
  ctx: CctpSdkContext,
  userAddress: Address
): Promise<CctpMoneyInTransitResponse> => {
  const response = await fetch(`${ctx.base}/cctp/money-in-transit/${userAddress}`)

  if (!response.ok) {
    throw await parseCctpError(response, 'Failed to fetch CCTP money in transit')
  }

  return response.json()
}
